export interface StorageStatus {
  supported: boolean;
  persisted: boolean;
  usageBytes?: number;
  quotaBytes?: number;
}

export class BrowserStoragePersistence {
  async status(): Promise<StorageStatus> {
    const storage = navigator.storage;
    if (!storage) return { supported: false, persisted: false };
    try {
      const [persisted, estimate] = await Promise.all([
        storage.persisted?.() ?? Promise.resolve(false),
        storage.estimate?.() ?? Promise.resolve({}),
      ]);
      return {
        supported: typeof storage.persist === "function",
        persisted,
        usageBytes: estimate.usage,
        quotaBytes: estimate.quota,
      };
    } catch {
      return { supported: typeof storage.persist === "function", persisted: false };
    }
  }

  /** The browser may refuse even when invoked from a user gesture. */
  async requestPersistence(): Promise<boolean> {
    try {
      return await (navigator.storage?.persist?.() ?? false);
    } catch {
      return false;
    }
  }
}
